export default "__VITE_ASSET__DvSlWPu5__"